import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const TestimonialsCarousel = () => {
  // All 20 testimonial images - update with your images as you upload them
  const testimonials = [
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/inl2d3mv_20190102_143749.jpg',
      alt: 'Student testimonial - Helen Wilkinson'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/u0z6axsg_20190102_143310.jpg',
      alt: 'Student testimonial - Marie Emery'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/t1hml8hs_20190102_144308.jpg',
      alt: 'Student testimonial - Karen Tunstall'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/r4zzlh0b_20190102_143530.jpg',
      alt: 'Student testimonial - Amanda Mortimer'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/w9hxq37n_20190102_143719.jpg',
      alt: 'Student testimonial 5'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/tx26awp7_20190102_144222.jpg',
      alt: 'Student testimonial 6'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/4ua39knp_20190102_143334.jpg',
      alt: 'Student testimonial 7'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/73tm2epi_20190102_143644.jpg',
      alt: 'Student testimonial 8'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/3i6tc0ns_20190102_144344.jpg',
      alt: 'Student testimonial 9'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/1swk5f1v_20190102_144245.jpg',
      alt: 'Student testimonial 10'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/i0vbtnex_20190102_144200.jpg',
      alt: 'Student testimonial 11'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/4tf1d658_20190102_143404.jpg',
      alt: 'Student testimonial 12'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/ywopg3fo_20190102_143458.jpg',
      alt: 'Student testimonial 13'
    },
    // Placeholders for remaining 7 testimonials - replace with actual URLs as you upload
    // {
    //   url: 'YOUR_IMAGE_URL_14',
    //   alt: 'Student testimonial 14'
    // },
    // ... add up to 20 total
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      align: 'start',
      slidesToScroll: 1,
      containScroll: 'trimSnaps'
    },
    [Autoplay({ delay: 5000, stopOnInteraction: false })]
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="testimonials-carousel-container">
      <div className="testimonials-header">
        <h2 className="section-title">What Our Students Say</h2>
        <div className="star-rating">
          <Star size={24} fill="var(--color-orange)" color="var(--color-orange)" />
          <Star size={24} fill="var(--color-orange)" color="var(--color-orange)" />
          <Star size={24} fill="var(--color-orange)" color="var(--color-orange)" />
          <Star size={24} fill="var(--color-orange)" color="var(--color-orange)" />
          <Star size={24} fill="var(--color-orange)" color="var(--color-orange)" />
        </div>
        <p className="testimonials-subtitle">Over 4,100+ satisfied students trained since 2006</p>
      </div>

      <div className="testimonials-embla" ref={emblaRef}>
        <div className="testimonials-embla__container">
          {testimonials.map((testimonial, index) => (
            <div className="testimonials-embla__slide" key={index}>
              <div className="testimonial-card">
                <img
                  src={testimonial.url}
                  alt={testimonial.alt}
                  className="testimonial-image"
                  loading={index < 3 ? 'eager' : 'lazy'}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        className="testimonials-button testimonials-button-prev"
        onClick={scrollPrev}
        aria-label="Previous testimonial"
      >
        <ChevronLeft size={28} />
      </button>

      <button
        className="testimonials-button testimonials-button-next"
        onClick={scrollNext}
        aria-label="Next testimonial"
      >
        <ChevronRight size={28} />
      </button>
    </div>
  );
};

export default TestimonialsCarousel;